// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $            from 'jquery';
import 'select2';

export default class SelectDesign extends WebComponent {
  didMount() {
    $(this.element).select2({
      minimumResultsForSearch: Infinity,
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/components/SelectDesign.js